import { render, staticRenderFns } from "./HtmlTag.vue?vue&type=template&id=10a1a662&"
import script from "./HtmlTag.vue?vue&type=script&lang=js&"
export * from "./HtmlTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports